import { render, staticRenderFns } from "./TourServices.vue?vue&type=template&id=4a18c5f0&scoped=true&"
import script from "./TourServices.vue?vue&type=script&lang=js&"
export * from "./TourServices.vue?vue&type=script&lang=js&"
import style0 from "./TourServices.vue?vue&type=style&index=0&id=4a18c5f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a18c5f0",
  null
  
)

export default component.exports